module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/code-ca94b3dcb3a62ff257a0e83820578fe0.svg";